const StatusImportacaoCertificado = Object.freeze({
  TODOS: 'Todos',
  IMPORTADOS: 'Importados',
  NAO_IMPORTADOS: 'Não Importados'
});

export default StatusImportacaoCertificado;
